import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../../shared/services/auth.service";

@Injectable(
  {providedIn: 'root'}
)
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth_service: AuthService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let access: Boolean = true;
    const token = this.auth_service.get_token();
    if (route.data.hasOwnProperty("roles")) {
      let roles = route.data["roles"] as Array<string>;
      let authRole = localStorage.getItem("auth_role");
      if (authRole != "admin") {
        if (roles[0] == authRole) {
          access = true;
        } else {
          access = false;
        }
      }
    }

    if (token && access) {
      return true;
    } else {
      this.router.navigateByUrl("/");
      return false;
    }
  }
}
